module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header'), _vm._v(" "), _c('main', {
    staticClass: "wrap",
    class: _vm.$style.work
  }, [_c('div', {
    class: _vm.$style.workItems
  }, _vm._l((_vm.items), function(item) {
    return _c('article', {
      class: _vm.$style.item
    }, [_c('router-link', {
      attrs: {
        "to": ("/work/" + (item.slug))
      }
    }, [(_vm.getImage(item)) ? _c('div', {
      class: _vm.$style.thumbnail
    }, [_c('img', {
      attrs: {
        "src": _vm.getImage(item)
      }
    })]) : _vm._e(), _vm._v(" "), _c('h2', {
      class: _vm.$style.title,
      domProps: {
        "innerHTML": _vm._s(item.title.rendered)
      }
    }), _vm._v(" "), _c('p', {
      class: _vm.$style.description,
      domProps: {
        "innerHTML": _vm._s(item.acf.description)
      }
    })])], 1)
  }), 0)]), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6deced4f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 115
// module chunks = 2